<template>
  <el-container>
    <el-header height="auto">
      <el-row align="middle" justify="flex-start" style="flex-wrap: wrap; margin: 10px 10px 0 0;" type="flex">
                <span style="margin: 10px 10px 0 0;">
                    <span :span="6" style="height: 100%; margin-right: 10px;">
                        <span style="height: 100%; line-height: 40px;">完成期限</span>
                    </span>
                    <span>
                        <el-date-picker
                            v-model="deadline"
                            align="right"
                            end-placeholder="截止日期"
                            range-separator="至"
                            start-placeholder="起始日期"
                            type="daterange"
                            unlink-panels
                            value-format="yyyy-MM-dd"
                            @change="deadlineChanged">
                        </el-date-picker>
                    </span>
                </span>
        <span style="margin: 10px 10px 0 0;">
                    <span style="height: 100%; margin-right: 10px">
                        <span style="height: 100%; line-height: 40px;">问题状态</span>
                    </span>
                    <span>
                        <el-select v-model="issueStatus" clearable placeholder="全部问题" @change="issueStatusChanged">
                            <el-option
                                v-for="item in issueStatusList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </span>
                </span>
        <span style="margin: 10px 10px 0 0;">
                    <span style="height: 100%; margin-right: 10px">
                        <span style="height: 100%; line-height: 40px;">活动</span>
                    </span>
                    <span>
                        <el-select v-model="activityId" clearable placeholder="全部活动" @change="activityChanged">
                            <el-option
                                v-for="item in activities"
                                :key="item.activityId"
                                :label="item.name"
                                :value="item.activityId">
                            </el-option>
                        </el-select>
                    </span>
                </span>
        <span style="margin: 10px 10px 0 0;">
                    <span style="height: 100%; margin-right: 10px">
                        <span style="height: 100%; line-height: 40px;">责任部门</span>
                    </span>
                    <span>
                        <el-select v-model="departmentId" clearable placeholder="全部部门" @change="departmentChanged">
                            <el-option
                                v-for="item in departments"
                                :key="item.departmentId"
                                :label="item.name"
                                :value="item.departmentId">
                            </el-option>
                        </el-select>
                    </span>
                </span>
        <span style="margin: 10px 10px 0 0;">
                    <el-button v-if="itemSelected.length !== 0 && user.roleId===1" type="danger"
                               @click="deleteButtonClicked">删除</el-button>
                    <el-button v-if="itemSelected.length !== 0 && user.roleId===1" type="primary"
                               @click="openEditIssueDialog">修改部门</el-button>
                    <el-button v-if="user.roleId===1" @click="exportAsExcelButtonClicked">导出为Excel</el-button>
                    <el-button v-if="user.userId===6236"
                               @click="exportAsPPTButtonClicked()">导出为PPT[限时免费]</el-button>
                </span>
      </el-row>
      <el-row align="middle" justify="flex-start" style="flex-wrap: wrap; margin: 20px 10px 0 0;" type="flex">
        <span style="color: darkgrey; font-size: 13px;">问题总数：{{ countOfAllIssues }}个</span>
      </el-row>
    </el-header>
    <el-dialog
        :visible.sync="excelDialogVisible"
        title="提示"
        width="30%">
      <span>您确定要导出{{ dialogContent }}问题为Excel吗?</span>
      <span slot="footer" class="dialog-footer">
                            <el-button @click="excelDialogVisible = false">取 消</el-button>
                            <el-button type="primary" @click="exportAsExcelButtonConfirmed()">确 定</el-button>
                        </span>
    </el-dialog>
    <el-dialog
        :visible.sync="pptDialogVisible"
        title="提示"
        width="30%">
      <span>您确定要导出{{ dialogContent }}问题为PPT吗?</span>
      <span slot="footer" class="dialog-footer">
                            <el-button @click="pptDialogVisible = false">取 消</el-button>
                            <el-button type="primary" @click="exportAsPPTButtonConfirmed()">确 定</el-button>
                        </span>
    </el-dialog>

    <el-dialog
        :visible.sync="editIssueDialog.visible"
        title="编辑问题"
        width="30%">
      <el-select v-model="editIssueDialog.departmentId" placeholder="责任部门">
        <el-option
            v-for="item in departments"
            :key="item.departmentId"
            :label="item.name"
            :value="item.departmentId">
        </el-option>
      </el-select>
      <span slot="footer" class="dialog-footer">
                    <el-button @click="editIssueDialog.visible = false">取 消</el-button>
                    <el-button type="primary" @click="changeDepartmentClicked">确 定</el-button>
                </span>
    </el-dialog>
    <el-main>
      <el-table
          :data="issues"
          style="width: 100%"
          @selection-change="selectionChanged">
        <el-table-column
            type="selection"
            width="55">
        </el-table-column>
        <el-table-column
            label="创建日期"
            prop="dateCreated"
            width="150">
        </el-table-column>
        <el-table-column
            label="问题状态"
            width="120">
          <template slot-scope="scope">
            <el-tag :type="scope.row.tagType">{{ scope.row.issueStatusName }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column
            label="描述"
            prop="description"
            width="300">
        </el-table-column>
        <el-table-column
            label="图片"
            width="140">
          <template slot-scope="scope">
            <img :src="scope.row.images[0]" height="100px" width="100px"
                 style="object-fit: cover; border-radius: 12px; border: 1px solid #dcdfe6;"/>
          </template>
        </el-table-column>
        <el-table-column
            label="活动名称"
            prop="activity.name"
            width="120">
        </el-table-column>
        <el-table-column
            label="发现人"
            prop="finder.name"
            width="120">
        </el-table-column>
        <el-table-column
            label="责任部门"
            prop="department.name"
            width="120">
        </el-table-column>
        <el-table-column
            label="类型"
            width="120">
          <template slot-scope="scope" v-if="scope.row.issueType">
            {{ scope.row.issueType.name }}
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          :page-size="20"
          :total="countOfAllIssues"
          background
          layout="prev, pager, next"
          @current-change="pageChanged">
      </el-pagination>
    </el-main>
  </el-container>
</template>

<script>
import axios from "axios";
import app from "@/App";

export default {
  name: "Issues",
  data() {
    return {
      user: {},
      issues: [],
      deadline: null,
      excelDialogVisible: false,
      dialogContent: '',
      pptDialogVisible: false,
      page: 1,
      countOfAllIssues: 0,
      searchCriteria: {
        startOfDeadline: '',
        endOfDeadline: '',
      },
      activeIndex: '1',
      activeIndex2: '1',
      itemSelected: [],
      ISSUE_STATUS_UNSOLVED: 0,
      ISSUE_STATUS_UNACCEPTED: 1,
      ISSUE_STATUS_ACCEPTED: 2,
      issueStatusList: [{
        value: null,
        label: '全部'
      }, {
        value: 0,
        label: '待解决'
      }, {
        value: 1,
        label: '待验收'
      }, {
        value: 2,
        label: '已验收'
      }],
      issueStatus: null,

      departmentId: null,
      departments: [],

      editIssueDialog: {
        visible: false,
        departmentId: null
      },

      activities: [],
      activityId: null,
      controller: new AbortController(),
    }
  },
  methods: {
    openLoginPage() {
      this.$router.replace({path: '/login'})
    },
    exportAsPPTButtonClicked() {
      this.setDialogContent()
      this.pptDialogVisible = true
    },
    setDialogContent() {
      if (this.itemSelected.length === 0) {
        this.dialogContent = "所有符合筛选条件"
      } else
        this.dialogContent = "选中的" + this.itemSelected.length + "个"
    },
    exportAsPPTButtonConfirmed() {
      this.pptDialogVisible = false
      this.exportAsPPT()
    },
    exportAsPPT() {
      axios.post(app.url + '/issue/exportAsPPT', {
        searchStartDate: this.deadline && this.deadline[0],
        searchEndDate: this.deadline && this.deadline[1],
        issueIds: this.itemSelected.map(v => v.issueId),
        issueStatuses: this.searchCriteria.issueStatus,
        activityId: this.searchCriteria.activityId,
        departmentId: this.searchCriteria.departmentId,
      }, {responseType: 'arraybuffer',}).then(() => {
        this.$message({
          message: "正在生成PPT，完成后将以手机短信的方式通知您",
          type: "success"
        });
        this.$refs.multipleTable.clearSelection();
      });
    },
    exportAsExcelButtonClicked() {
      this.setDialogContent();
      this.excelDialogVisible = true
    },
    exportAsExcelButtonConfirmed() {
      this.excelDialogVisible = false;
      axios.post(app.url + '/issue/exportAsExcel', {
        searchStartDate: this.deadline ? this.deadline[0] : '',
        searchEndDate: this.deadline ? this.deadline[1] : '',
        activityId: this.activityId,
        departmentId: this.departmentId,
        issueStatuses: this.issueStatus == null ? null : [this.issueStatus],
        issueIds: this.itemSelected.map(v => v.issueId),
      }, {responseType: 'arraybuffer',}).then(res => {
        const blob = new Blob([res.data]); // 创建blob对象
        const fileName = "爱精益-问题列表" + new Date().toDateString() + ".xls";
        const elink = document.createElement("a"); // 创建的标签
        elink.download = fileName;
        elink.style.display = "none";
        elink.href = URL.createObjectURL(blob); // 创建url
        document.body.appendChild(elink); // 把 创建的标签追加到body里
        elink.click();
        URL.revokeObjectURL(elink.href); // 释放URL 对象
        document.body.removeChild(elink); // 移除标签
        this.$message({
          message: "导出成功！！！",
          type: "success"
        });
        this.$refs.multipleTable.clearSelection();
      });
    },
    selectionChanged(dataSelected) {
      this.itemSelected = dataSelected;
    },
    deleteButtonClicked() {
      let issueIds = [];

      this.itemSelected.forEach(value => issueIds.push(value.issueId));

      axios.post(app.url + '/issue/deleteIssues', {
        issueIds: issueIds
      }).then(() => {
        alert('删除成功');
        this.searchCriteriaChanged();
      })
    },
    changeDepartmentClicked() {
      this.itemSelected.forEach(value => {
        app.methods.updateIssue(value.issueId, this.editIssueDialog.departmentId, () => {
          this.searchCriteriaChanged();
          this.closeEditIssueDialog();
        });
      });
    },
    openEditIssueDialog() {
      this.editIssueDialog.visible = true;
    },
    closeEditIssueDialog() {
      this.editIssueDialog.visible = false;
    },
    activityChanged() {
      this.searchCriteria.activityId = this.activityId;
      this.searchCriteriaChanged();
    },
    issueStatusChanged() {
      if (this.issueStatus === "" || this.issueStatus === null) {
        this.searchCriteria.issueStatus = [0, 1, 2]
      } else {
        this.searchCriteria.issueStatus = [this.issueStatus];
      }

      this.searchCriteriaChanged();
    },
    departmentChanged() {
      console.log('departmentChanged')
      this.searchCriteria.departmentId = this.departmentId;
      this.searchCriteriaChanged();
    },
    download(url) {
      let a = document.createElement('a');
      a.href = '/lfc/' + url;
      // a.click();
    },
    deadlineChanged(deadline) {
      this.searchCriteria.startOfDeadline = deadline ? deadline[0] : '';
      this.searchCriteria.endOfDeadline = deadline ? deadline[1] : '';
      this.searchCriteriaChanged();
    },
    getProblems() {
      this.controller.abort()
      this.controller = new AbortController();
      app.methods.getIssues({
        searchStartDate: this.searchCriteria.startOfDeadline,
        searchEndDate: this.searchCriteria.endOfDeadline,
        issueStatuses: this.searchCriteria.issueStatus,
        activityId: this.searchCriteria.activityId,
        departmentId: this.searchCriteria.departmentId,
        page: this.page,
        pageSize: 20
      }, this.controller.signal).then(response => {
            this.issues = response.data.data.list
          }
      );
      app.methods.getCountOfAllIssues().then(res => {
        this.countOfAllIssues = 0
        for (const statistics of res.data.data) {
          this.countOfAllIssues += statistics.count
        }
      });
    },
    pageChanged(page) {
      this.page = page;
      this.getProblems();
    },
    searchCriteriaChanged() {
      this.page = 1;
      this.getProblems();
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    },
    async getActivities() {
      let activities = (await app.methods.getActivities(this.user.company.companyId)).data.data.list;
      activities.unshift({activityId: null, name: '全部'})
      this.activities = activities;
    },
    async getDepartments() {
      this.departments = (await app.methods.getAllDepartmentsOfCompany(this.user.company.companyId)).data.data;
    }
  },
  created() {
    app.methods.getUser().then(res => {
      this.user = res.data.data;
      this.searchCriteriaChanged();
      this.getDepartments();
      this.getActivities();
    });
  },
}
</script>

<style scoped>

</style>
